export const isMaintenanceMode = (
  value: string | undefined = import.meta.env.VITE_MAINTENANCE_MODE,
): boolean => value?.trim().toLowerCase() === 'true';
